import { fetchCart } from '@/lib/cart';
import { getThemes } from '@/lib/indexFunctions';

export default ({ context }) => {
  const init = async () => {
    const cart = await fetchCart();
    
    window.theme = window.theme || {};
    window.theme.cart = cart;
    
    // Dispatch event to notify components that data is ready
    context.dispatchEvent('cart:fetched', { cart });
  };

  // Re-fetch on cart changes
  document.addEventListener('cart:added', init);
  document.addEventListener('cart:updated', init);

  // Initial fetch
  init();
};
